import React from "react";
import Typography from "@material-ui/core/Typography";
const GlobalCustomer = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Global Customer
      </Typography>
      <Typography paragraph variant="h5">
        Grow the business, innovate, and deliver the best thing together with
        Invifo.
      </Typography>
      <Typography paragraph variant="body1">
        Invifo Global Customer is a worldwide customer who use the Invifo
        Platform to run their core business, the customers who share the same
        passion and vision to seek millions of benefits of the Invifo solutions.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Reasons why companies want to become Invifo Global Customers.
      </Typography>
      <Typography paragraph variant="body1">
        For the majority of businesses in scale small to medium, it is quite
        difficult to have a proper system that can help to run the business from
        end-to-end in a simple way. It is not only because of the complicated
        process flow or even too less covered process, but also it is due to the
        high price of license on majority ERP system. That is why the Invifo
        Platform trying to be the best answer to these issues. There are tons of
        benefits offered for being an Invifo Global Customer.
      </Typography>
      <div className="row justify-content-center mt-5">
        <div className="col-sm-4 col-md-4 col-lg-4">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 text-center mt-3">
              <Typography component="span" align="center">
                <i className="fas fa-wallet fa-4x kt-font-brand"></i>
              </Typography>
              <Typography
                variant="h6"
                align="center"
                className="kt-font-bolder mt-3"
              >
                Affordable Pricing
              </Typography>
              <Typography align="center">
                We offer something you cannot refuse. Most small-medium
                businesses cannot afford to buy the proper system to run their
                business due to the high price and complexity. That is what the
                Invifo platform trying to solve. Our prices are still
                reasonable, not too complicated, and offering all we have got to
                customers. No upgrade & support fees for cloud version if we
                launch the new features. Customers will have every evolution of
                Invifo could offer.
              </Typography>
            </div>
          </div>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 text-center mt-3">
              <Typography component="span" align="center">
                <i className="fas fa-route fa-4x kt-font-brand"></i>
              </Typography>
              <Typography
                variant="h6"
                align="center"
                className="kt-font-bolder mt-3"
              >
                End-to-End Features
              </Typography>
              <Typography align="center">
                We provide a complete ecosystem for all customer needs in a
                simplified way. Our ecosystem covers the core company process
                like Sales, Inventory, Procurement, Finance, and CRM. That is
                not last but not least, later we will have Production, Human
                Capital Management, Supplier & Vendor Portal, Bidding Portal,
                Document Management System, B2B Market, and even AI for
                business.
              </Typography>
            </div>
          </div>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 text-center mt-3">
              <Typography component="span" align="center">
                <i className="fas fa-code-branch fa-4x kt-font-brand"></i>
              </Typography>
              <Typography
                variant="h6"
                align="center"
                className="kt-font-bolder mt-3"
              >
                Simple & Efficient on Process
              </Typography>
              <Typography align="center">
                We bring process simplicity to speed up the company's processing
                time. The complicated system design of most majority ERP
                providers is a common problem that companies face. But, Invifo
                learn from this situation, which is why we designed the Invifo
                platform as simple as possible for users' convenience and focus
                on what's important in the process for efficiency.
              </Typography>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center mt-5">
        <div className="col-sm-4 col-md-4 col-lg-4">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 text-center mt-3">
              <Typography component="span" align="center">
                <i className="fas fa-share-alt fa-4x kt-font-brand"></i>
              </Typography>
              <Typography
                variant="h6"
                align="center"
                className="kt-font-bolder mt-3"
              >
                Seamless Integration
              </Typography>
              <Typography align="center">
                We give the best quality to customers. All modules in the Invifo
                platform are integrated and automated very well to support
                customer's business. Most companies use multiple platforms to
                cover all their business processes and sometimes this makes the
                process not integrated seamlessly and leads to huge costs to
                automate it. On the other hand, Invifo offers an ecosystem where
                everything is already integrated and automated with no more
                cost.
              </Typography>
            </div>
          </div>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 text-center mt-3">
              <Typography component="span" align="center">
                <i className="fas fa-cogs fa-4x kt-font-brand"></i>
              </Typography>
              <Typography
                variant="h6"
                align="center"
                className="kt-font-bolder mt-3"
              >
                Maintenance & Support
              </Typography>
              <Typography align="center">
                We make customers smile. Maintenance of the system is something
                that must be done by companies to provide a good performance of
                the system and it will cost them very high. Asking for support
                from the system providers is sometimes also not free, making the
                company expense increase. But, there are no fees required for
                maintenance and support for our Invifo platform cloud version.
              </Typography>
            </div>
          </div>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 text-center mt-3">
              <Typography component="span" align="center">
                <i className="fas fa-bullhorn fa-4x kt-font-brand"></i>
              </Typography>
              <Typography
                variant="h6"
                align="center"
                className="kt-font-bolder mt-3"
              >
                Product Marketing Support
              </Typography>
              <Typography align="center">
                We help to promote our customer's products or even help to find
                some products. Other system provider does not care about
                customers' business, but Invifo does. We care about our
                customers. Seeing our customer's business grows is something
                special for us. That is why we provide an ecosystem of B2B
                Market to connect our customers.
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default GlobalCustomer;
